import { render, staticRenderFns } from "./ProfileUser.vue?vue&type=template&id=02cf5aca"
import script from "./ProfileUser.vue?vue&type=script&lang=js"
export * from "./ProfileUser.vue?vue&type=script&lang=js"
import style0 from "./ProfileUser.vue?vue&type=style&index=0&id=02cf5aca&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02cf5aca')) {
      api.createRecord('02cf5aca', component.options)
    } else {
      api.reload('02cf5aca', component.options)
    }
    module.hot.accept("./ProfileUser.vue?vue&type=template&id=02cf5aca", function () {
      api.rerender('02cf5aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProfileUser.vue"
export default component.exports